import * as React from "react";
import { Box, Button, Grid, IconButton } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import GppGoodIcon from "@mui/icons-material/GppGood";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useMutation } from "react-query";
import { DeleteCartItem, GetCartSummary } from "../../service/store.service";
import { ApiResultModel } from "../../../models/common.model";
import { StoreResponse } from "../../models/store.model";
import CancelModal from "../modals/cancelModal";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useHistory } from "react-router-dom";
import { number } from "prop-types";
import { useDispatch } from "react-redux";
import { setCartCount } from "../../redux/cartSummary/cartCountAction";
import CartSkeleton from "./cartSkeleton";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import { PRODUCT_KEY } from "../../../config/cacheKey";
import { v4 as uuid } from "uuid";

export default function CartCard({
  cartItem,
  setUpdateCart,
  validationIssues,
}: any) {
  const history = useHistory<{
    key: string;
    orderId: number;
    inventoryId: number;
    count: number;
  }>();

  const [openCancelModal, setOpenCancelModal] = React.useState<boolean>(false);

  function deletItem() {
    setOpenCancelModal(true);
  }
  function editItem() {
    sessionStorage.setItem(PRODUCT_KEY, cartItem.productKey);
    history.replace({
      pathname: "/products/productCategory1/productList1/ProductDetail",
      state: {
        key: cartItem.productKey,
        orderId: cartItem.orderId,
        inventoryId: cartItem.inventoryId,
        count: cartItem.count,
      },
    });
  }
  const dispatch = useDispatch();
  const cartSummaryMutate = useMutation(GetCartSummary, {
    onSuccess: (data) => {
      dispatch(setCartCount({ count: data.data }));
    },
  });
  const handleCancel = (e: any, l: any) => {
    cartSummaryMutate.mutate();
  };
  return cartItem ? (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Grid container>
        {validationIssues.length !== 0 ? (
          <Grid item xs={12} className="duringHint">
            <WarningAmberIcon
              style={{ color: "#827717", marginRight: "20px" }}
            />
            <ul>
              {validationIssues.map((item: any) => (
                <li>
                  <span style={{ color: "#827717" }}>{item}</span>
                </li>
              ))}
            </ul>
          </Grid>
        ) : (
          ""
        )}
        <Grid
          container
          xs={12}
          spacing={2}
          style={{ marginTop: "15px", height: "fit-content" }}
          className={validationIssues.length !== 0 ? "cartOpacity" : ""}
        >
          <Grid item xl={1.5} lg={2} style={{ justifyContent: "end" }}>
            <Grid item xs={12} className="cartImg">
              <img
                style={{ width: "80px", height: "80px" }}
                className="classCenter"
                src={`images/Mobile.png`}
                alt="طرح انتخابی"
              />
            </Grid>
            <Grid
              item
              xs={12}
              className="cartCount"
              style={{ marginTop: "10px", display: " grid" }}
            >
              <span className="colorTitle textFont12 fontWeight">
                {" "}
                تعداد : {cartItem?.count}
              </span>
            </Grid>
          </Grid>
          <Grid item xl={10.5} lg={10}>
            <Grid container xs={12}>
              <Grid item xl={10} lg={10}>
                <Grid item xs={12}>
                  <span className="fontWeight">{cartItem?.title}</span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: "15px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <span
                    className="duringDot"
                    style={{ backgroundColor: cartItem?.colorCode }}
                  ></span>
                  <span
                    className="fontMedium"
                    style={{ marginRight: "10px", font: "12px" }}
                  >
                    {cartItem?.colorTitle}
                  </span>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "15px" }}>
                  <span style={{ color: "#1D4A87" }}>
                    <GppGoodOutlinedIcon />
                  </span>
                  <span
                    className="colorTitle textFont12 fontMedium"
                    style={{ marginRight: "10px" }}
                  >
                    {cartItem?.guarantyDescription}
                  </span>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "15px" }}>
                  <span style={{ color: "#F06292" }}>
                    <AutoAwesomeIcon />
                  </span>
                  <span
                    className="fontMedium"
                    style={{ marginRight: "10px", color: "#F06292" }}
                  >
                    مهلت تایید نهایی درخواست: {cartItem?.expirationDate_Persian}
                  </span>
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ marginTop: "5px" }}>
                <hr />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container xs={12}>
          <Grid
            item
            xl={1.5}
            lg={2}
            md={2}
            xs={0}
            style={{ justifyContent: "end" }}
          ></Grid>
          <Grid
            item
            xl={10.5}
            lg={10}
            md={10}
            xs={12}
            sm={12}
            style={{ paddingRight: "27px", marginTop: "-6px" }}
          >
            <Grid
              container
              xs={12}
              columns={{ xs: 4, sm: 8, md: 12 }}
              className={validationIssues.length !== 0 ? "cartOpacity" : ""}
            >
              <Grid item xs={12} sm={12} xl={7} lg={7} md={7}>
                <Grid container xs={12}>
                  <Grid
                    item
                    xs={8}
                    xl={6}
                    md={8}
                    sm={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Grid container xs={12}>
                      <Grid item xs={3} xl={3} lg={3} md={6}>
                        <Grid container xs={12}>
                          <Grid item xs={12} style={{ marginBottom: "6px" }}>
                            <span
                              className="fontMedium"
                              style={{ color: "#1D4A87" }}
                            >
                              قیمت پایه
                            </span>
                          </Grid>
                          <Grid item xs={12} style={{ marginBottom: "6px" }}>
                            <span
                              className="fontMedium"
                              style={{ color: "#1D4A87", marginBottom: "6px" }}
                            >
                              جمع کل
                            </span>
                          </Grid>
                          <Grid item xs={12} style={{ marginBottom: "6px" }}>
                            <span
                              className="fontMedium"
                              style={{ color: "#E6123D" }}
                            >
                              تخفیف
                            </span>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={4} xl={4} lg={4} md={6}>
                        <Grid container xs={12} style={{ textAlign: "end" }}>
                          <Grid item xs={12} style={{ marginBottom: "6px" }}>
                            <span
                              style={{ color: "#424242", fontWeight: "bold" }}
                            >
                              {cartItem?.basePrice.toLocaleString("fa")}{" "}
                            </span>
                            <span style={{ font: "12px", color: "#424242" }}>
                              ریال
                            </span>
                          </Grid>
                          <Grid item xs={12} style={{ marginBottom: "6px" }}>
                            <span
                              style={{ color: "#424242", fontWeight: "bold" }}
                            >
                              {cartItem?.totalAmount.toLocaleString("fa")}{" "}
                            </span>
                            <span style={{ font: "12px", color: "#424242" }}>
                              ریال
                            </span>
                          </Grid>
                          <Grid item xs={12}>
                            <span
                              style={{ color: "#E6123D", fontWeight: "bold" }}
                            >
                              {cartItem?.discountAmount.toLocaleString("fa")}{" "}
                            </span>
                            <span style={{ font: "12px", color: "#E6123D" }}>
                              ریال
                            </span>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    xl={6}
                    md={4}
                    sm={12}
                    style={{ borderLeft: "1px solid #E0E0E0" }}
                  ></Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} xl={5} lg={5} md={5}>
                <Grid container xs={12}>
                  <Grid item xl={8} lg={10} style={{ marginTop: "10px" }}>
                    <Grid
                      container
                      xs={12}
                      style={{ paddingRight: "10px", alignItems: "center" }}
                    >
                      <Grid item xs={4}>
                        <span
                          className="fontMedium"
                          style={{ color: "#1D4A87" }}
                        >
                          قابل پرداخت
                        </span>
                      </Grid>
                      <Grid item xs={8}>
                        <span
                          style={{
                            color: "#424242",
                            fontWeight: "bold",
                            fontSize: "20px",
                          }}
                        >
                          {cartItem?.finalAmount.toLocaleString("fa")}{" "}
                        </span>
                        <span style={{ fontSize: "12px", color: "#424242" }}>
                          ریال
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xl={4} lg={2}></Grid>

                  <Grid container xs={12}></Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        xl={2}
        lg={2}
        style={{ textAlign: "end" }}
        sx={{ position: "absolute", top: "10px", left: "10px" }}
      >
        <Grid
          item
          xs={12}
          style={
            validationIssues.length === 0
              ? { marginTop: "10px" }
              : { marginTop: "80px" }
          }
        >
          <Button
            onClick={editItem}
            style={{
              // pointerEvents: "none",
              // cursor: "not-allowed",
              maxWidth: "6px",
              minWidth: "6px",
            }}
            className="editIcon"
            disabled={validationIssues.length !== 0}
          >
            <span
              onClick={editItem}
              style={
                validationIssues.length === 0
                  ? { opacity: "1" }
                  : { opacity: "0.6" }
              }
            >
              <EditOutlinedIcon className="editIcon" />
            </span>
          </Button>
          <span
            style={{
              color: "#CFD8DC",
              marginRight: "10px",
              marginLeft: "10px",
            }}
          >
            |
          </span>
          <span onClick={deletItem} className="activeIcon">
            <DeleteOutlineOutlinedIcon className="delIcon" />
          </span>
        </Grid>
      </Grid>
      <CancelModal
        setOpenCancelModal={setOpenCancelModal}
        openCancelModal={openCancelModal}
        serviceName={DeleteCartItem}
        requestModel={{
          inventoryId: cartItem?.inventoryId,
          orderId: cartItem?.orderId,
        }}
        setUpdateCart={setUpdateCart}
        response={StoreResponse}
        handleCancel={handleCancel}
      />
    </Box>
  ) : (
    <CartSkeleton />
  );
}
